import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aef721e86e75bd1211e599f9f4001c7f0b from "./generated-e877e285-947d-4c98-a27d-5b24a52db49c.json";

import ad7bdcb9b5b4df32583782844ed73de86b from "./generated-95bbc35e-e9b3-4a04-9ceb-1f3c89bd35fd.json";

import a5479d644fd606f8f46909ca97a76e8cfb from "./generated-8e26bcd9-55fa-4fb0-8d4f-3e345522c707.json";

import a4a14f73172dccc610dab98f6f0bcfb2db from "./generated-1e0dd4e5-df82-44fe-88cc-de2d510e10d5.json";

import ad90dca89f2b027eca0cb7da70588bc60b from "./generated-3c927840-3d24-4572-922e-4f888e27f35c.json";

import a88a07fe77f25676f0eaafb7f5043e9f8b from "./generated-f307a206-9f65-4a23-91c5-7d4afa620f93.json";

import a59577820923a81e46989ab55a0e73eb5b from "./generated-34c7b26e-dcb0-4e06-86a5-bd60fc29fa65.json";

import ab0dfa7e3eac842220602e68e0b029addb from "./generated-4900f512-d2da-40a5-b67e-813f873f217d.json";

import a002eb530f9e457bab5e06a0d37ccb50bb from "./generated-0ed6333b-b75f-4563-86c4-15ba0d976a69.json";

import a0d12eb55201d49cacf427a04b7a5b28db from "./generated-1b635793-e4a8-49c7-9ea1-35917ca506e0.json";

import abddecc6fdff3ffb77c109e89079e2509b from "./generated-6ad63026-228d-47df-8aa5-3e65e47808cc.json";

import a5af71679762a81d4c74c8f4922ad5ac5b from "./generated-5fb8f231-92f4-4d11-b707-1fd909d29f8f.json";

import afb51703f3f1127df0ab3f8dc5579179cb from "./generated-e64c713b-ad52-48bf-8f04-37cc7420f694.json";

import a766268b0e157f70651df56d36e53deaab from "./generated-b9e19baf-e474-4fe7-ad6b-33f286970da3.json";

import aac69b94022da0c57403830f22519a89cb from "./generated-a82ba5ab-b52d-4e0d-98b0-b2af3a86a7ce.json";

import a7b7bc5d4c3add7ff9b5cd9d2b7ab6c5bb from "./generated-d5ed8e68-8b37-45df-95ed-6b02e8cc7da5.json";

import aa34f4de0aa302403246def26c8d7b521b from "./generated-40b1dd75-abe3-4843-8e25-239d57eb0003.json";

import adbc8ee556b42c22b6750b0d9a7e314ebb from "./generated-dcc7cf5e-9322-4126-b3b0-123e4b2f3c96.json";

import acb7eee3e5442a62d5595fc7527014f92b from "./generated-5ec7891d-19d2-455e-89fe-fc0a80d6568f.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aef721e86e75bd1211e599f9f4001c7f0b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ad7bdcb9b5b4df32583782844ed73de86b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a5479d644fd606f8f46909ca97a76e8cfb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a4a14f73172dccc610dab98f6f0bcfb2db);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ad90dca89f2b027eca0cb7da70588bc60b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a88a07fe77f25676f0eaafb7f5043e9f8b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a59577820923a81e46989ab55a0e73eb5b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab0dfa7e3eac842220602e68e0b029addb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a002eb530f9e457bab5e06a0d37ccb50bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a0d12eb55201d49cacf427a04b7a5b28db);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(abddecc6fdff3ffb77c109e89079e2509b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a5af71679762a81d4c74c8f4922ad5ac5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(afb51703f3f1127df0ab3f8dc5579179cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a766268b0e157f70651df56d36e53deaab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aac69b94022da0c57403830f22519a89cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a7b7bc5d4c3add7ff9b5cd9d2b7ab6c5bb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aa34f4de0aa302403246def26c8d7b521b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(adbc8ee556b42c22b6750b0d9a7e314ebb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(acb7eee3e5442a62d5595fc7527014f92b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aa34f4de0aa302403246def26c8d7b521b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */